import { getPlaybackState, putShuffleMode } from "../controllers/SpotifyApiController";
import { getPointedDeviceId } from "../reducers/devices";
import { getCurrentItem } from "../reducers/playbackState";
import { manageTooManyRequestsResponse } from "../utils/connectionUtils";

export const SET_PLAYBACK_STATE = 'SET_PLAYBACK_STATE';
export const SET_CURRENT_ITEM = 'SET_CURRENT_ITEM';

export const updatePlaybackState = () => 
{
    return (dispatch, getState) => 
    {
        const state = getState();
        const currentItem = getCurrentItem(state);
        const pointedDeviceId = getPointedDeviceId(state);

        return getPlaybackState()
            .then((result) => {
                // If there is already a pointed device and the result object has a status property equal to 204 (empty response), then...
                if(pointedDeviceId && result.status === 204)
                {
                    //... the shuffle mode is set to false (we don't want it set as true anyway), which will force to actually get a no-empty response when trying to get the playback state
                    putShuffleMode(false, pointedDeviceId)
                    .then()
                    .catch((error) => {
                        manageTooManyRequestsResponse(error, dispatch);
                        console.error('*Error fetching current playback state: ', error);
                    });
                }
                // If the result object has an item property, it means that the response has not been empty. It is actually the playback state
                else if(result.item)
                {
                    // Then, if the currently playing item is different from the one that is saved in the state
                    if(!currentItem || currentItem.id !== result.item.id)
                    {
                        // Then, it is changed
                        dispatch({ type: SET_CURRENT_ITEM, payload: result.item });
                    }

                    // And the playback state saved in the general state is also updated
                    dispatch({ type: SET_PLAYBACK_STATE, payload: result });
                    // And nothing more is done
                    return;
                }

                // In any other case, the current item and the playback state values in the general state are reset
                dispatch({ type: SET_CURRENT_ITEM, payload: undefined });
                dispatch({ type: SET_PLAYBACK_STATE, payload: undefined });
            })
            .catch((error) => {
                dispatch({ type: SET_CURRENT_ITEM, payload: undefined });
                dispatch({ type: SET_PLAYBACK_STATE, payload: undefined });

                manageTooManyRequestsResponse(error, dispatch);
                console.error('Error fetching current playback state: ', error);
            })
    }
}